module.exports = __webpack_public_path__ + "images/icon_next_8c3149c57301c22c4027d0d649985993.svg";